import React from 'react'
import style from './articles.style'

const YclientsHelp = ({ classes }) => {
  return (
    <article className={classes.article}>
      <h2>Подключение Yclients</h2>
      <h3>Шаг 1. Настройка авторизации CRM</h3>

      <figure className={classes.helpArticleFigure}>
        <img src="/images/crm/yclients/1.png" alt="true" />
      </figure>

      <h3>Шаг 2. Настройка Yclients</h3>

      <ol>
        <li>
          Перейдите в личный кабинет Yclients, что произвести необходимые настройки.
          <figure className={classes.helpArticleFigure}>
            <img src="/images/crm/yclients/2.png" alt="true" />
          </figure>
        </li>

        <li>
          В выпадающем меню, выберите необходимую вам <b>“СЕТЬ”</b>
          <figure className={classes.helpArticleFigure}>
            <img src="/images/crm/yclients/3.png" alt="true" />
          </figure>
        </li>

        <li>
          Перейдите в раздел <strong>Настройки > Дополнительные поля</strong>
          <figure className={classes.helpArticleFigure}>
            <img src="/images/crm/yclients/4.png" alt="true" />
          </figure>
        </li>

        <li>
          Нажмите кнопку <strong>“+ Добавить поле”</strong>
          <figure className={classes.helpArticleFigure}>
            <img src="/images/crm/yclients/5.png" alt="true" />
          </figure>
        </li>

        <li>
          В новом окне, в строке <strong>“Название”</strong>, напишите <strong>“Google Client ID (CID)”</strong>. В строке <strong>“Ключ-значение для API”</strong>, напишите <strong>“gcid”</strong>. Важно! “gcid” нужно писать обязательно маленькими буквами. Нажмите кнопку <strong>“Сохранить”</strong>.
          <figure className={classes.helpArticleFigure}>
            <img src="/images/crm/yclients/6.png" alt="true" />
          </figure>
        </li>

        <li>Вернитесь в “<strong>Личный кабинет</strong>” и перейдите в раздел <strong>Настройки > WebHook.</strong></li>
        <li>
          <ol>
            <li>В строке “Адрес, на который отправлять уведомления” вставьте ссылку </li>
            <li>https://romi.center/api/yclients</li>
            <li>Поставьте галочку напротив “Событие по записям” и нажмите кнопку </li>
            <li><strong>“Сохранить”.</strong></li>
          </ol>
          <figure className={classes.helpArticleFigure}>
            <img src="/images/crm/yclients/7.png" alt="true" />
          </figure>
        </li>
      </ol>

      <h3>Шаг 3. Финальная настройка в ROMI center</h3>

      <ol>
        <li>
          <p>Выберите, куда хотите отправлять данные. Мы рекомендуем отправлять данные в <strong>“Покупки в электронной торговле”</strong>. Отправка данных в <strong>Электронную торговлю</strong> позволяет передавать дополнительные данные: название товара/услуги, количество, цену, передавать данные о возвратах и другое.</p>

          <p>Отправка данных в Цель <strong>“Успешные продажи”</strong>, позволяет передавать только сумму продаж.</p>
          <figure className={classes.helpArticleFigure}>
            <img src="/images/crm/yclients/8.png" alt="true" />
          </figure>
        </li>

        <li>Выберите филиалы, из которых необходимо отправлять данные о продажах.</li>
        <li>Выберите поле, в которое у вас передается Google Client ID (CID).</li>
        <li>Нажмите кнопку <strong>Подключить</strong>, далее нажмите кнопку <strong>Завершить</strong>.</li>
      </ol>

      <p>Поздравляем, crm успешно подключена! </p>
    </article>
  )
}

export default style(YclientsHelp)
